


import { map } from 'rxjs/operators';


import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import { ConfigService } from '../../../config/config.service';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type':  'application/json', 
     })
   }

@Injectable()
export class RegistrationService { 
 baseUrl;
    constructor(private http:HttpClient, config: ConfigService) {
    
     this.baseUrl = config.get('extApiUrl');
     if (!this.baseUrl) {
         config.load().then(() => {
             this.baseUrl = config.config['extApiUrl'];
         });
     }
    }     

    registerUser(input) {
   
       console.log(this.baseUrl);    
        return this.http.post<any>(this.baseUrl + 'api/UserManagement/registerUser', JSON.stringify(input), httpOptions ).pipe(map(responsedata => {       
               let body = responsedata;
               return body || {};
      }));
   }
}
